"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.UPDATE_RESTRICTIONS = exports.GET_RESTRICTION_FAIL = exports.GET_RESTRICTION_SUCCESS = exports.GET_RESTRICTION_REQUEST = exports.NAME = void 0;
var immutable_1 = require("immutable");
var core_1 = require("@gin-betting/core");
exports.NAME = 'restrictions';
exports.GET_RESTRICTION_REQUEST = exports.NAME + "/GET_RESTRICTION:REQUEST";
exports.GET_RESTRICTION_SUCCESS = exports.NAME + "/GET_RESTRICTION:SUCCESS";
exports.GET_RESTRICTION_FAIL = exports.NAME + "/GET_RESTRICTION:FAIL";
exports.UPDATE_RESTRICTIONS = exports.NAME + "/UPDATE_RESTRICTIONS";
var RestrictionsStateRecord = immutable_1.Record({
    fetchStatus: core_1.App.FetchStatus.INITIAL,
    betslipRestrictions: immutable_1.OrderedMap(),
}, 'RestrictionsState');
exports.initialState = new RestrictionsStateRecord();
//# sourceMappingURL=constants.js.map